import styled from 'styled-components'
import { GREEN, GREY, GREY_DARK, WHITE } from '../../utils/colors'
import { MD } from '../../utils/screenSizes'

type ContainerSideNavigationMenuProps = {
  $isOpen: boolean;
}

export const Container = styled.ul`
  background-color: ${WHITE};
  width: 336px;
  padding: 52px 22px;

  .modal_close {
    cursor: pointer;
    position: absolute;
    top: 25px;
    right: 25px;
    background: transparent;
    border: none;
  }

  @media (max-width: ${MD}) {
    display: block;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 1000;
    background-color: ${WHITE};
  }
`

export const ContainerSideNavigationMenu = styled.li<ContainerSideNavigationMenuProps>`
  margin: 34px 0 0 0;

  .inside {
    transition: max-height linear 0.2s;
    overflow: hidden;
    max-height: ${props => props.$isOpen ? '200px' : '0px'};
  }

  &:first-child {
    .title_container:before {
      background: transparent !important;
    }
  }

  .title_container {
    border: none;
    background: transparent;
    position: relative;
    display: block;
    width: 100%;
    text-align: left;
    cursor: pointer;

    &:before {
      position: absolute;
      content: '';
      width: 24px;
      top: -24px;
      height: 2px;
      flex-grow: 0;
      left: 29px;
      background-color: ${GREY};
    }

    .arrow {
      margin-right: 10px;
      svg {
        transform: rotate(${props => props.$isOpen ? '180deg' : '0deg'});
        stroke: ${props => props.$isOpen ? GREEN : GREY_DARK};
        width: 20px;
      }
    }

    .title {
      display: block;
      flex: 1;
    }

    color: ${props => props.$isOpen ? GREEN : GREY_DARK};
    font-family: Mont, sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.44;
    letter-spacing: normal;
    display: flex;
    margin-top: 36px;

    .icon {
      margin: 0px 23px;

      svg {
        fill: ${props => props.$isOpen ? GREEN : GREY_DARK};
        width: 24px;
      }
    }
  }
`
export const ContainerSideNavigationItem = styled.li`
  margin: 18px 70px;
  min-height: 36px;
  font-size: 14px;
  color: ${GREY_DARK};
  line-height: 1.43;
  letter-spacing: normal;

  a {
    color: inherit;
    text-decoration: none;
  }
`
